<template lang="pug">
  .container
    .header {{$t('Screens selected')}}
      el-button.remove-all-button(id="SelectedDesktopsList-deselectAllButton" @click="clearDesktopsSelectedRight()", type='text', size='big', :title='$t("Deselect screens")')
        font-awesome-icon(v-if="this.$store.state.Device.desktops_selected_right.length > 0", icon="check-square")
        font-awesome-icon(v-if="this.$store.state.Device.desktops_selected_right.length === 0", icon="square")
      hr.header
    .row(v-for="selectedDesktop in this.$store.state.Device.desktops_selected_right", :key="selectedDesktop.id", :id="'SelectedDesktopsList-desktop'+selectedDesktop.id")
      .thumbnail
        img.dimensionsContainer(:src="selectedDesktop.deviceDesktopScreenShotFilename ? selectedDesktop.deviceDesktopScreenShotFilename : playListThumbnailById(selectedDesktop.LocalPlayList)")
      .name
        span.medium-name &nbsp;&nbsp;
          | {{ getFullDeviceNameByDesktopId(selectedDesktop.id) }}
      .remove
        el-button(:id="'SelectedDesktopsList-deselectDesktop'+selectedDesktop.id", @click="removeDesktopSelectedRight(selectedDesktop)", type='text', size='big', circle, :title='$t("Deselect screen")')
          font-awesome-icon(icon="check-square")
</template>

<script>
import MediumIcon from '../Common/MediumIcon'
import ListItemMixin from '../Medium/ListItem.mixin'
import mediaUtils from '../Common/mediaUtils.mixin'
import textUtils from '../Common/textUtils.mixin'

export default {
  props: [],
  components: {
    MediumIcon
  },
  mixins: [ListItemMixin, mediaUtils, textUtils],
  created () {
  },
  watch: {
    items: async function (newVal, oldVal) {
    }
  },
  data () {
    return {
      errors: {}
    }
  },
  methods: {
    playListThumbnailById (mediumId) {
      let medium = this.$store.state.Medium.media_list.find(
        medium => medium.id === mediumId
      )
      if (!medium) return
      return this.getThumbnailPath(medium.File)
    },
    removeDesktopSelectedRight (desktop) {
      this.$store.dispatch('Device/removeDesktopSelectedRight', desktop)
    },
    clearDesktopsSelectedRight () {
      this.$store.dispatch('Device/clearDesktopsSelectedRight')
    }
  },
  computed: {
  }
}
</script>
<style lang="scss" scoped>
@import "../../../theme-m4b/src/common/var.scss";
  .container {
    display: flex;
    flex-direction: column;
    .header {
      margin-top: 30px;
      .remove-all-button {
        float: right;
        margin: -15px 30px 0px 0px;
        font-size: 20px;
      }
    }
    .row {
      display: flex;
      padding: 10px 10px;
      border-bottom: $--border-base;
      color: $--color-text-primary;
      font-size: $--font-size-small;
      align-items: center;
      justify-content: space-between;
      .name {
        overflow: hidden;
        // width: 20%;
        flex-grow: 2;
        margin-left: 20px;
      }
      .thumbnail {
        overflow: hidden;
        img {
          max-width: 100px;
        }
      }
      .remove {
        margin-right: 10px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Device/SelectedDesktopsList.vue